<wiz-hgroup #vgEdition wizValidationContainer width="100%" height="100%" gap="5" padding="3px" class="section-container-parent">
  <!-- entête d'édition -->
  <wiz-vgroup wizValidationContainer width="200px" height="100%" class="section-container" padding="5px" gap="10">
    <wiz-text-input
      #tiCode
      [wizPlaceholder]="'$.common.define.$'"
      [wizValidator]="uniqueCodeValidator()"
      [wizLabel]="'$.common.code.$'"
      width="100%"
      class="upper-case-input"
      [wizShowErrors]="true"
      [wizMandatory]="true"
      [wizMaxChars]="20"
      [wizValue]="code" 
    >
    </wiz-text-input>
    <wiz-translation-basic
      #trsDesc
      [wizTranslationMode]="'textarea'"
      [maxTranslation]="6"
      [translationData]="transDesc"
      [wizLabel]="'$.common.description.$'"
      width="100%"
      height="80px"
    ></wiz-translation-basic>
    <wiz-spacer width="100%"></wiz-spacer>

    <!-- boutons d'action -->
    <wiz-vgroup gap="0" height="100%" width="100%" horizontalAlign="center" verticalAlign="end">
      <wiz-button
        #btnSave
        [wizIcon]="'arrow-right'"
        [wizLabel]="'$.common.save.modification.$'"
        [iconPlacement]="'right'"
        [wizDisabled]="disableButtons()"
        (wizClick)="doMerge()"
      ></wiz-button>
      <wiz-button
        #btnCancel
        class="cancel-button"
        (wizClick)="doCancel()"
        [wizIcon]="'arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-vgroup>
  </wiz-vgroup>

  <!-- détail d'édition -->
  <!--liste des lignes du style -->
  <wiz-vgroup width="100%" height="100%" class="section-container" style="overflow-x: auto">
    <wiz-hgroup [verticalAlign]="'center'" gap="10" >
      <wiz-icon [wizTooltip]="'$.style.line.add.$'"  tooltipPlacement="right" class="image-back-orange" (click)="askForAddLine()">add</wiz-icon>
      <wiz-label class="smallTitleLabel" [wizLabel]="'$.style.line.add.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
    </wiz-hgroup>

    <wiz-list #lstStyles width="100%" height="100%" [itemHeight]="100" [wizItemRenderer]="lineRenderer"></wiz-list>
  </wiz-vgroup>
</wiz-hgroup>
